import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastrModule } from 'ngx-toastr';
import { ButtonComponent } from './buttons/button.component';
import { InputComponent } from './input/input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectComponent } from './select/select.component';
import { OptionComponent } from './option/option.component';
import { PageHeaderComponent } from './page-header/page-header.component';
import { AvatarComponent } from '../avatar/avatar.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TablePaginationComponent } from '../../shared/table-pagination/table-pagination.component';
import { FeedbackModalComponent } from '../../shared/feedback-modal/feedback-modal.component';
import { UserNotificationsComponent } from '../../shared/user-notifications/user-notifications.component';
import { UserMenuComponent } from '../../shared/user-menu/user-menu.component';
@NgModule({
  declarations: [
    ButtonComponent,
    InputComponent,
    SelectComponent,
    OptionComponent,
    PageHeaderComponent,
    AvatarComponent,
    TablePaginationComponent,
    FeedbackModalComponent,
    UserNotificationsComponent,
    UserMenuComponent,
  ],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, NgbModule, ToastrModule.forRoot()],
  exports: [
    ButtonComponent,
    InputComponent,
    SelectComponent,
    OptionComponent,
    PageHeaderComponent,
    AvatarComponent,
    TablePaginationComponent,
    FeedbackModalComponent,
    UserNotificationsComponent,
    UserMenuComponent,
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class UiModule {}
